$(document).ready(function(){

    let formBuscar = document.querySelector("#formBuscar")
    if(formBuscar != null){
        formBuscar.addEventListener("submit", (e) => {
            e.preventDefault()
            let formData = new FormData(formBuscar)
            location.href = "/" + formData.get("listado") + "?s=" + formData.get("buscar");
        })
    }

    $('.owl-banner').owlCarousel({
        dots: true,
        margin:10,
        nav:false,
        autoplay: true,      // Enable automatic sliding
        autoplayTimeout: 5000, // Time in milliseconds between slides (3s)
        autoplayHoverPause: true,
        responsive:{
            0:{
                items:1
            },
        }
    })
});
